import type { Actor } from './types';

// Pure: caller passes the tie-break random number explicitly.
export function rollInitiative(p1Agility: number, p2Agility: number, tieRng: number): Actor {
  if (p1Agility > p2Agility) return 'p1';
  if (p2Agility > p1Agility) return 'p2';
  return tieRng < 0.5 ? 'p1' : 'p2';
}
